import BaseContainer from "@base/container/BaseContainer"
import * as PIXI from "pixi.js";
import ScaleManager from "@/stage/ScaleManager"
import Facade from "@/Facade";
import {Signals} from "@/Imports"
import GameBackgroundContainer from "@/containers/GameBackgroundContainer";
import PlaneContainer from "@/containers/PlaneContainer";
import MultiplierContainer from "@/containers/MultiplierContainer";
import MakeBetsContainer from "@/containers/MakeBetsContainer";
import CurtainContainer from "@/containers/CurtainContainer";
import Config from "@/config/Config";
import Utils from "@base/utils/Utils";
import FeatureContainer from "./FeatureContainer";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import SkyContainer from "./SkyContainer";
import StarsContainer from "@/containers/StarsContainer";
import PlatformContainer from "@/containers/PlatformContainer";
import FreezingContainer from "@/containers/FreezingContainer";
import SnowContainer from "@/containers/SnowContainer";
import RewardContainer from "@/containers/RewardContainer";

export default class MainContainer extends BaseContainer {

  constructor() {
    super()
    this.isCreated = false
    this.interactive = false

    Facade.mainContainer = this

    this.init()

    Signals.continueBtnClick.add(this.onContinueBtnClick, this)
    Signals.chatVisibilityChange.add(this.onChatVisibilityChange, this)

    Signals.roundEnd.add(this.onStopFeature, this)
    Signals.stopFeature.add(this.onStopFeature, this)
    Signals.startFeature.add(this.onStartFeature, this)
    Signals.makeBets.add(this.onMakeBets, this)
  }

  init() {
    this.onOrientationChanged(Facade.orientation)

    this.generalContainer = new PIXI.Container()
    this.addChild(this.generalContainer)

    this.sky = new SkyContainer()
    this.generalContainer.addChild(this.sky)

    this.starsContainer = new StarsContainer()
    this.generalContainer.addChild(this.starsContainer)

    this.gameBackground = new GameBackgroundContainer()
    this.generalContainer.addChild(this.gameBackground)

    this.danger = new SpineAnimation('danger')
    this.danger.scale.set(0.5)
    this.generalContainer.addChild(this.danger)
    this.danger.visible = false

    this.snowContainer = new SnowContainer()
    this.generalContainer.addChild(this.snowContainer)

    this.platformContainer = new PlatformContainer('Bot');
    this.generalContainer.addChild(this.platformContainer)

    this.bulletsContainer = new PIXI.Container()
    this.planeContainer = new PlaneContainer({bulletsContainer: this.bulletsContainer})

    this.generalContainer.addChild(this.planeContainer)

    this.platformContainer = new PlatformContainer('Top');
    this.generalContainer.addChild(this.platformContainer)

    this.featureContainer = new FeatureContainer()
    this.generalContainer.addChild(this.featureContainer)
    this.generalContainer.addChild(this.bulletsContainer)

    this.multiplierContainer = new MultiplierContainer()
    this.planeContainer.container.addChild(this.multiplierContainer)

    this.makeBetsContainer = new MakeBetsContainer()
    this.generalContainer.addChild(this.makeBetsContainer)

    this.curtainContainer = new CurtainContainer()
    this.generalContainer.addChild(this.curtainContainer)

    this.freeinzgContainer = new FreezingContainer()
    this.generalContainer.addChild(this.freeinzgContainer)
    this.freeinzgContainer.position.set(440,290)

    this.rewardContainer = new RewardContainer()
    this.generalContainer.addChild(this.rewardContainer)

    window.dispatchEvent(new Event('resize'))

    Signals.graphicsCreated.dispatch()

    this.setPositions()

    this.isCreated = true

  }

  onStopFeature() {
    this.danger.visible = false
    this.danger.stop()
  }

  onStartFeature() {
    this.danger.visible = true
    this.danger.start(['warning'], [true])
    Facade.soundManager.play('gameWarningSound', 0.7)
  }

  onMakeBets() {
  }

  onContinueBtnClick() {
    Signals.chatVisibilityChange.dispatch(true)
  }

  onChatVisibilityChange(visible) {
    Facade.rootDIV = document.getElementById('root')
    Facade.rootDIV.style.visibility = visible ? "visible" : "hidden"
  }

  onOrientationChanged(orientationSymbol) {
    switch (orientationSymbol) {
      case 'Hm':
      case 'Vm':
      case 'Hd':
        Config.currentPattern = Config.pattern.desktop
        break
        /*
                Config.currentPattern = Config.pattern.desktop
                break*!/

                Config.currentPattern = Config.pattern.desktop
                break*/
    }
    if(this.isCreated) {
      this.setPositions()
    }
  }

  setPositions() {
    //this.createGeneralMask()
    //this.createViewportMask()

    // TODO: Feature container
    Utils.applyFromPattern(this.featureContainer, Config.currentPattern.boss)
    Utils.applyFromPattern(this.makeBetsContainer, Config.currentPattern.makeBetsContainer)
    Utils.applyFromPattern(this.planeContainer, Config.currentPattern.planeContainer)
    Utils.applyFromPattern(this.multiplierContainer, Config.currentPattern.multiplierContainer)
    Utils.applyFromPattern(this.platformContainer, Config.currentPattern.main)
    Utils.applyFromPattern(this.danger, Config.currentPattern.danger)

    Utils.applyFromPattern(this.bulletsContainer, Config.currentPattern.planeContainer)

    this.multiplierContainer.y += 40
    this.featureContainer.y -= 30

    switch (Facade.orientation) {
      case 'Hd':
        this.generalContainer.visible = true
        break

      case 'Hm':
        this.generalContainer.visible = false
        break

      case 'Vm':
        this.generalContainer.visible = true
        break
    }
  }

  createGeneralMask() {
    if(this.generalMask) {
      this.removeChild(this.generalMask)
      this.generalMask = null
    }
    this.generalMask = new PIXI.Graphics()
    this.generalMask.beginFill(0xffffff)
    this.generalMask.drawRect(0, 0, ScaleManager.currentSizes.total.width, ScaleManager.currentSizes.total.height)
    this.generalMask.endFill()
    this.mask = this.generalMask
    this.addChild(this.generalMask)
  }
/*
  createViewportMask() {
    if(this.backMask) {
      this.removeChild(this.backMask)
      this.backMask = null
    }
    this.backMask = new PIXI.Graphics()
    this.backMask.beginFill(0xfff3ff)
    this.backMask.drawRoundedRect(Config.currentPattern.mainMask.x, Config.currentPattern.mainMask.y, Config.currentPattern.mainMask.width, Config.currentPattern.mainMask.height, 15)
    this.backMask.endFill()
    this.generalContainer.mask = this.backMask
    this.addChild(this.backMask)
  }*/



}
